import { render, staticRenderFns } from "./SegTablaPostulante.vue?vue&type=template&id=09a568a4&scoped=true&"
import script from "./SegTablaPostulante.vue?vue&type=script&lang=js&"
export * from "./SegTablaPostulante.vue?vue&type=script&lang=js&"
import style0 from "./SegTablaPostulante.vue?vue&type=style&index=0&id=09a568a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a568a4",
  null
  
)

export default component.exports